import {
  CV_EDUCATIONFORM_FETCHITEM_LOAD,
  CV_EDUCATIONFORM_FETCHITEM_SUCCEED,
  CV_EDUCATIONFORM_FETCHITEM_FAIL,
  CV_EDUCATIONFORM_EDITFORM_CHANGE,
  CV_EDUCATIONFORM_ENTER_RESET,
  CV_EDUCATIONFORM_CREATEITEM_LOAD,
  CV_EDUCATIONFORM_CREATEITEM_SUCCEED,
  CV_EDUCATIONFORM_CREATEITEM_FAIL,
  CV_EDUCATIONFORM_EDITITEM_LOAD,
  CV_EDUCATIONFORM_EDITITEM_SUCCEED,
  CV_EDUCATIONFORM_EDITITEM_FAIL,
  CV_EDUCATIONFORM_DELETEITEM_LOAD,
  CV_EDUCATIONFORM_DELETEITEM_SUCCEED,
  CV_EDUCATIONFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case CV_EDUCATIONFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case CV_EDUCATIONFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case CV_EDUCATIONFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case CV_EDUCATIONFORM_ENTER_RESET:
      return {}
    case CV_EDUCATIONFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case CV_EDUCATIONFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case CV_EDUCATIONFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case CV_EDUCATIONFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case CV_EDUCATIONFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case CV_EDUCATIONFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case CV_EDUCATIONFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case CV_EDUCATIONFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case CV_EDUCATIONFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case CV_EDUCATIONFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
